import { InputBase, Modal, Button, Typography, Backdrop, CircularProgress, IconButton } from "@mui/material";
import { AES } from "crypto-js";
import { ethers } from "ethers";
import KwilDB from "kwildb";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addNewMoat } from "../../../redux/slices/moatNameSlice";
import { setPrivateKey } from "../../../redux/slices/privateKeySlice";
import CloseIcon from '@mui/icons-material/Close';

export default function CreateMoat({ addingMoat, setAddingMoat, setError, loader, setLoader, emptyInput, setEmptyInput, closeModal, setSuccess }) {
    const [newMoatName, setNewMoatName] = useState("")
    //need to fix conditional render for if the signing phrase is incorrect
    const [newPhrase, setNewPhrase] = useState("")
    
    const dispatch = useDispatch()

    //need to fix auto close on submission
    function createMoat() {
        setLoader(true)
        setTimeout(async function () {
            try {
                await window.ethereum.send("eth_requestAccounts")
                const provider = new ethers.providers.Web3Provider(window.ethereum)
                const signer = provider.getSigner()
                const signature = await signer.signMessage(newPhrase)
                const address = await signer.getAddress()
                const result = await KwilDB.createMoat(
                    "https://test-db.kwil.xyz",
                    newMoatName,
                    signature,
                    address
                )
                if (result.creation === false) {
                    setError(result.reason)
                    setLoader(false)
                    setAddingMoat(false)
                    setEmptyInput(false)
                } else {
                    const temp = await KwilDB.getMoats(
                        "https://test-db.kwil.xyz",
                        address
                    )
                    dispatch(addNewMoat(temp)) // this might be wrong
                    setAddingMoat(false)
                    setLoader(false)
                    setSuccess("Data set successfully created! Please select your dataset from the dropdown menu.")
                }
            } catch (error) {
                setError(error.toString())
                setLoader(false)
                setAddingMoat(false)
                setEmptyInput(false)
            }
            
       }, 0)
    }


    return(
        <Modal
            open={addingMoat}
            onClose={() => {
                closeModal()
            }}
            sx={{ display: "flex" }}
        >
            <div className="modal-intro moat">
                <p className="modal-title">
                    Create New Data Set
                </p>
                <Typography
                    sx={{
                        margin: "22px 32px 0px",
                        color: "#fff",
                        fontFamily: "Averta",
                        fontWeight: "400" }}>
                    Data Set Name{emptyInput && <span>*</span>}
                </Typography>
                <InputBase 
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 32px",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta",
                      }}
                    onChange={(e) => setNewMoatName(e.target.value.toLowerCase().replace(/[^a-zA-Z0-9_ ]/g, '').replace(" ", "_").replace(/^[^a-zA-Z]/, ''))}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            if(newMoatName && newPhrase) {
                                e.preventDefault()
                                createMoat()
                            } else {
                                setEmptyInput(true)
                                setError("You must include a Moat Name and Signing Phrase.")
                            }
                            
                        }
                    }}
                    placeholder="Data Set Name"
                    value={newMoatName}
                />
                
                <Typography
                    sx={{
                        margin: "29px 32px 0px",
                        color: "#fff",
                        display: "flex",
                        fontFamily: "Averta",
                        fontWeight: "400"
                    }}
                >
                    Signing Phrase {emptyInput && <span>*</span>}
                </Typography>
                <InputBase 
                    sx={{
                        backgroundColor: "#040417",
                        color: "#fff",
                        borderRadius: "9px",
                        pl: "10px",
                        minHeight: "45px",
                        margin: "5px 32px",
                        border: "1px solid #114BA3",
                        fontFamily: "Averta"
                      }}
                    onChange={(e) => setNewPhrase(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            if(newMoatName && newPhrase) {
                                e.preventDefault()
                                createMoat()
                            } else {
                                setEmptyInput(true)
                                setError("You must include a Moat Name and Signing Phrase.")
                            }
                            
                        }
                    }}
                    placeholder="Signing Phrase"
                    value={newPhrase}
                />
                <Button
                    type="submit"
                    sx={{
                      color: "#fff",
                      background: "linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)",
                      opacity: "0.9",
                      textTransform: "none",
                      margin: "40px auto",
                      borderRadius: "9px",
                      width: "19.028vw",
                      height: "49px",
                      fontFamily: "Averta",
                      fontWeight: "400",
                      fontSize: "20px",
                      lineHeight: "24px"
                    }}
                    onClick={(e) => {
                        if(newMoatName && newPhrase) {
                            e.preventDefault()
                            createMoat()
                        } else {
                            setEmptyInput(true)
                            setError("You must include a Moat Name and Signing Phrase.")
                        }
                    }}
                >Create Data Set</Button>
                <Backdrop open={loader} sx={{ display: "flex" }}>
                    <CircularProgress sx={{ margin: "auto", color: "#linear-gradient(90deg, #118EA0 0%, #50C9DB 100%)" }} />
                </Backdrop>
            </div>
        </Modal>
    )
}